import * as actiontypes from './actionTypes';


export const setLanguage =(lang)=>{
    return (dispatch )=>{
        console.log(lang);
        dispatch({type:actiontypes.SET_LANGUAGE, lang:lang});

    }
}